import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=1eec3ef0&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Start.vue"
export default component.exports